import { z } from 'zod';

import { isoDatetimeToDate } from '../../codecs';
import { Position } from '../../roster';

export type SessionReportDataQuery = z.output<typeof sessionReportDataQuerySchema>;
export type SessionReportDataQueryDTO = z.input<typeof sessionReportDataQuerySchema>;

export const sessionReportDataQuerySchema = z.object({
  playerIds: z.union([z.uuid(), z.array(z.uuid())]).catch([]),
  groupId: z.uuid().nullable().catch(null),
  position: z.enum(Position).nullable().catch(null),
  start: z.union([isoDatetimeToDate, z.array(isoDatetimeToDate)]).catch([]),
  end: z.union([isoDatetimeToDate, z.array(isoDatetimeToDate)]).catch([]),
});
